export default __webpack_public_path__ + "static/Reach25ProspectusCover-cb611e8f03c39cb2e65d93e28b69e710.jpg";